import React from 'react';

const r = (Component, renderBool = true) => function rp(props) {
  if (!renderBool) return null;
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} />;
};

export default r;
